import { Component, h } from 'preact'
import Header from '../header'
import { GroupData, HeroImageData } from './Overview'
import GroupEditTabs from './GroupTabs'
import GroupInfoPanel from './GroupInfoPanel'
import DynamicSaveBar from '../ui-components/DynamicSaveBar'
import Axios from 'axios'
import AlertComponent from '../ui-components/AlertComponent'

interface Props {
  group: GroupData,
  id: number,
  isSuccess: boolean
}

interface State extends GroupData {
  src: null | string,
  crop: {
    x: number,
    y: number,
    width: number,
    height: number,
    aspect: number
  },
  pixelCrop: {
    width: number,
    height: number,
    x: number,
    y:number
  },
  isLoading: boolean,
  messageType: null | 'success' | 'error',
  message: null|string,
  titleError?: string,
  descriptionError?: string,
  activeTab: number
}

export class GroupEdit extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    const { title, description, heroImage } = props.group

    this.state = {
      title: title || '',
      description: description || '',
      heroImage: heroImage || null,
      src: null,
      crop: {
        x: 0,
        y: 0,
        width: 120,
        height: 60,
        aspect: 2
      },
      pixelCrop: {
        width: 120,
        height: 60,
        x: 0,
        y: 0
      },
      isLoading: false,
      messageType: null,
      message: null,
      titleError: '',
      descriptionError: '',
      activeTab: 0
    }

    this.groupTabs = ['Group Details']
    this.savedGroupInfo = {
      title: title || '',
      description: description || '',
      heroImage: heroImage || null
    }
    this.resetChanges = this.resetChanges.bind(this)
    this.onSave = this.onSave.bind(this)
  }

  groupTabs: Array<string>
  savedGroupInfo: GroupData

  async onSave () {
    let errors: {
      title?: string,
      description?: string
    } = {}
    if (this.state.title === '') {
      errors.title = 'Please fill in this field'
    }

    if (this.state.description === '') {
      errors.description = 'Group description can’t be blank'
    }

    if (Object.keys(errors).length) {
      this.setState({
        titleError: errors.title || '',
        descriptionError: errors.description || ''
      })

      return
    }

    this.setState({ isLoading: true, messageType: null })
    const { title, description, heroImage } = this.state
    try {
      await Axios.post(`/platform/group/${this.props.id}`, {
        title: title,
        description: description,
        heroImage: heroImage
      })

      this.savedGroupInfo = {
        title,
        description,
        heroImage
      }

      this.setState({ isLoading: false, messageType: 'success', message: null })
    } catch (err) {
      this.setState({
        isLoading: false,
        messageType: 'error',
        message: null
      })
    }
  }

  resetChanges () {
    this.setState({
      title: this.savedGroupInfo.title,
      description: this.savedGroupInfo.description,
      heroImage: this.savedGroupInfo.heroImage
    })
  }

  componentDidMount () {
    if (this.props.isSuccess) {
      this.setState({ messageType: 'success', message: 'New group is added successfully!' })
    }
  }

  render (_: Props, { title, description, heroImage, isLoading, messageType, message, titleError, descriptionError, activeTab }: State) {
    const displaySaveBar = this.savedGroupInfo.title !== title || this.savedGroupInfo.description !== description || JSON.stringify(this.savedGroupInfo.heroImage) !== JSON.stringify(heroImage)

    return (
      <div className='group-edit-page'>
        <Header
          title='Edit group'
          disableCancelButton
          disableSaveButton
          hasBreadcrumb
          breadcrumbText='Back to group overview'
          breadcrumbLink='/platform/groups'
        />
        { messageType ? <AlertComponent sticky messageType={messageType} message={message} isVisibleFor={3000} /> : null }
        <GroupEditTabs
          tabs={this.groupTabs}
          activeTab={activeTab}
          onCallback={(activeTab: number) => this.setState({ activeTab: activeTab })}
        />
        {
          this.groupTabs[activeTab] === 'Group Details' ? (
            <GroupInfoPanel
              title={title}
              updateTitle={(title: string) => this.setState({ title: title, titleError: '' })}
              description={description}
              updateDescription={(description: string) => this.setState({ description: description, descriptionError: '' })}
              heroImage={heroImage}
              updateHeroImage={(heroImage: HeroImageData|null) => this.setState({ heroImage: heroImage })}
              titleError={titleError}
              descriptionError={descriptionError}
            />
          ) : null
        }

        {
          displaySaveBar ? (
            <DynamicSaveBar
              isLoading={isLoading}
              cancelCallback={this.resetChanges}
              saveCallback={this.onSave} />
          ) : null
        }
      </div>
    )
  }
}

export default GroupEdit
